import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.array.concat.js";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, HStack, Pressable, Text } from "native-base";
import BrandIcon from "../../common/BrandIcon";
import { useStore } from "@dp/state";
import i18next from "i18next";

var ShareButton = function ShareButton() {
  var _store$reservation, _navigator, _store$reservation2, _store$reservation2$r, _store$reservation2$r2;

  var store = useStore();
  var reservationModel = store === null || store === void 0 ? void 0 : (_store$reservation = store.reservation) === null || _store$reservation === void 0 ? void 0 : _store$reservation.reservationModel;
  var time = reservationModel === null || reservationModel === void 0 ? void 0 : reservationModel.preferredTime;
  var isShareAvailable = !!((_navigator = navigator) !== null && _navigator !== void 0 && _navigator.share);
  var reservationDateinTimestamp = reservationModel === null || reservationModel === void 0 ? void 0 : reservationModel.reservationDateinTimestamp;
  var dateFull = new Date(reservationDateinTimestamp);
  var date = dateFull === null || dateFull === void 0 ? void 0 : dateFull.getDate();
  var month = dateFull === null || dateFull === void 0 ? void 0 : dateFull.toLocaleString("default", {
    month: "short"
  });
  var guests = reservationModel === null || reservationModel === void 0 ? void 0 : reservationModel.noOfGuests;
  var restName = store === null || store === void 0 ? void 0 : (_store$reservation2 = store.reservation) === null || _store$reservation2 === void 0 ? void 0 : (_store$reservation2$r = _store$reservation2.reservationModel) === null || _store$reservation2$r === void 0 ? void 0 : (_store$reservation2$r2 = _store$reservation2$r.restDetails) === null || _store$reservation2$r2 === void 0 ? void 0 : _store$reservation2$r2.restaurantName;
  var isMobile = store === null || store === void 0 ? void 0 : store.isMobile;
  var confirmationUrl = "";

  var shareRestInfo = function shareRestInfo(title, url, text) {
    var _navigator2;

    (_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : _navigator2.share({
      title: title,
      url: url,
      text: text
    })["catch"](function (err) {
      console.log("error in share:", err);
    });
  };

  var shareBtnURL = function shareBtnURL() {
    var _URL, _window, _window$location;

    var origin = (_URL = new URL((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.href)) === null || _URL === void 0 ? void 0 : _URL.origin;
    return "".concat(origin).concat(confirmationUrl);
  };

  var shareBtnText = function shareBtnText() {
    return i18next.t("share.reservation_confirmation.message", {
      defaultValue: "Your Reservation at ".concat(restName, " \non ").concat(month, " ").concat(date, " at ").concat(time, ", Party Size ").concat(guests),
      interpolation: {
        prefix: "${",
        suffix: "}"
      },
      0: restName,
      1: month,
      2: date,
      3: time,
      4: guests
    });
  };

  return /*#__PURE__*/_jsx(Box, {
    children: isShareAvailable ? /*#__PURE__*/_jsx(Box, {
      mt: {
        base: 0,
        md: 4
      },
      borderTopWidth: {
        base: 0,
        md: 1
      },
      borderTopColor: "reservationBorderColor",
      pt: {
        base: 0,
        md: 4
      },
      alignItems: "center",
      children: /*#__PURE__*/_jsx(Pressable, {
        onPress: function onPress() {
          shareRestInfo(restName, shareBtnURL(), shareBtnText());
        },
        children: /*#__PURE__*/_jsxs(HStack, {
          space: 2,
          children: [isMobile ? /*#__PURE__*/_jsx(BrandIcon, {
            alt: "share",
            iconName: "share",
            h: "18px",
            w: "16px"
          }) : /*#__PURE__*/_jsx(BrandIcon, {
            alt: "share-two",
            iconName: "share-two",
            h: "18px",
            w: "16px"
          }), !isMobile ? /*#__PURE__*/_jsx(Text, {
            color: "primary.100",
            fontSize: 14,
            underline: true,
            children: i18next.t("reservation_text_share", {
              defaultValue: "Share"
            })
          }) : null]
        })
      })
    }) : null
  });
};

export default ShareButton;